import { Table, Typography, Skeleton } from 'antd'
import moment from 'moment'
import { useRouter } from 'next/router'
import { EmptyBoxIcon } from 'src/components/CustomIcon'
import CustomTag from 'src/components/CustomTag'
import { handleURI } from 'src/utils/common'

const { Text } = Typography

const Detail = ({ orderList, setIsDetail }) => {
	const router = useRouter()

	const columns = [
		{
			title: 'Mã đơn hàng',
			dataIndex: 'orderCode',
			key: 'orderCode',
			render: (text, record) => (
				<a
					aria-label={'247Express-Nhanh hơn bạn nghĩ'}
					onClick={() => {
						router.push('/tra-cuu-van-don/' + handleURI(record?.orderCode))
						setIsDetail(true)
					}}
				>
					{text}
				</a>
			),
		},
		{
			title: 'Ngày nhập',
			dataIndex: 'acceptTime',
			key: 'acceptTime',
			render: (text) => <span>{text && moment(text).format('DD/MM/YYYY')}</span>,
		},

		{
			title: 'Trạng thái',
			key: 'trackingName',
			dataIndex: 'trackingName',
			render: (text, item) => {
				return text && <CustomTag text={text} />
			},
		},
		{
			title: 'Ngày phát',
			dataIndex: 'deliveryDate',
			key: 'deliveryDate',
			render: (text) => <span>{text && moment(text).format('DD/MM/YYYY HH:mm')}</span>,
		},
		{
			title: 'Người ký nhận',
			key: 'deliveryTo',
			dataIndex: 'deliveryTo',
		},
		{
			title: 'Ghi chú',
			key: 'notes',
			dataIndex: 'notes',
		},
	]

	if (!orderList) {
		return (
			<div className="tracking-table">
				<Skeleton active />
			</div>
		)
	}

	return orderList.length ? (
		<div className="tracking-table">
			<Table
				columns={columns}
				dataSource={orderList}
				scroll={{ x: true }}
				rowKey={'orderCode'}
				pagination={orderList.length > 10}
			/>
		</div>
	) : (
		<div className="tracking-empty">
			<EmptyBoxIcon />
			<Text className="text">Không có dữ liệu</Text>
		</div>
	)
}

export default Detail
